module.exports = __webpack_public_path__ + "image/quotationtop_ic.bbf899da.png";